// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Discover: React.FC = () => {
    return (
        <svg
            width="40"
            height="24"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            fill="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <defs>
                <rect x="0" y="0" width="40" height="24" rx="4" />
                <path d="M9.646 24h26.355C38.209 24 40 22.215 40 19.993v-6.514S29.28 20.747 9.646 24z" />
            </defs>
            <g fill="none" fillRule="evenodd" opacity=".9">
                <g>
                    <rect stroke="#666666" x=".5" y=".5" width="39" height="23" rx="4" />
                    <use fill="#666666" xlinkHref="#b" />
                </g>
                <path
                    d="M7.315 11.929c-.3.257-.682.369-1.293.369h-.254V9.234h.254c.61 0 .978.105 1.293.374a1.557 1.557 0 010 2.32zm-1.104-3.48H4.823v4.634h1.38c.734 0 1.263-.167 1.728-.536a2.288 2.288 0 00.879-1.78c0-1.368-1.068-2.318-2.6-2.318zM9.246 8.449h.94v4.634h-.94zM12.498 10.225c-.568-.2-.734-.332-.734-.583 0-.29.296-.511.704-.511.283 0 .516.108.764.373l.492-.617a2.164 2.164 0 00-1.422-.515c-.857 0-1.51.57-1.51 1.325 0 .64.304.965 1.19 1.274.37.123.558.207.654.264a.547.547 0 01.283.478c0 .377-.313.654-.735.654-.449 0-.812-.215-1.03-.62l-.609.565c.436.61.958.883 1.676.883.98 0 1.672-.628 1.672-1.523 0-.737-.32-1.071-1.395-1.447M14.19 10.767c0 1.363 1.117 2.419 2.556 2.419.406 0 .754-.077 1.182-.27V11.85c-.378.364-.71.507-1.14.507-.951 0-1.625-.658-1.625-1.597 0-.888.695-1.591 1.583-1.591.448 0 .79.152 1.182.521V8.627c-.414-.2-.753-.283-1.163-.283-1.43 0-2.576 1.077-2.576 2.423M25.58 11.56L24.287 8.45h-1.03l2.053 4.751h.507l2.092-4.751H26.89l-1.31 3.111M28.339 13.083h2.678v-.785h-1.733v-1.251h1.667v-.785h-1.667V9.234h1.733v-.785H28.34v4.634M32.862 10.58h-.274V9.178h.29c.59 0 .905.237.905.689 0 .464-.316.713-.921.713zm1.894-.764c0-.868-.622-1.367-1.713-1.367h-1.402v4.634h.947V11.22h.122l1.305 1.863h1.162l-1.524-1.953c.712-.14 1.103-.605 1.103-1.314z"
                    fill="#1A1919"
                />
                <path
                    d="M23.392 10.778c0 1.334-1.13 2.416-2.525 2.416-1.394 0-2.524-1.082-2.524-2.416 0-1.334 1.13-2.416 2.524-2.416 1.395 0 2.525 1.082 2.525 2.416"
                    fill="#666666"
                />
            </g>
        </svg>
    );
};

export default React.memo(Discover);
